import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportInfringementsCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'

export function ExportInfringements() {
  const translations = useTranslate({
    infringements: 'common.infringements',
  })

  return (
    <ExportSection header={translations.infringements}>
      <ExportInfringementsCard />
    </ExportSection>
  )
}
